import * as React from "react";
import { useState } from "react";
import { BaseModal } from "../../atoms/base-modal";
import { GroupShareSelectField } from "../../molecules/group-share-select-field";
import {
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";

export const GroupShareModal: React.FC<{
  onClose: () => void;
  tenantId?: string; // Service-Providerの場合のみ指定
  sharedGroupIds: string[];
  onAdd: (groupId: string) => void;
}> = ({ tenantId, sharedGroupIds, onClose, onAdd }) => {
  const [sharedGroupId, setSharedGroupId] = useState<string>(
    sharedGroupIds.length > 0 ? sharedGroupIds[0] : "",
  );
  if (sharedGroupIds.length > 1) {
    // 現時点では1:1しか許容していないので、エラーにしておく
    throw new Error("shared groupId must be smaller than 1");
  }
  return (
    <BaseModal
      title={"管理グループ設定"}
      isActive={true}
      onClose={onClose}
      hasOverflow={true}
    >
      <section className="modal-card-body">
        <article className="message">
          <div className="message-body">
            グループに所属するユーザーのみ閲覧や編集が可能になります。
          </div>
        </article>
        <GroupShareSelectField
          tenantId={tenantId}
          selectedGroupId={sharedGroupId}
          onChange={setSharedGroupId}
        />
      </section>
      <section className="modal-card-foot is-justify-content-center">
        <SecondaryButton type="button" onClick={onClose} text={"閉じる"} />
        <PrimaryButton
          type="button"
          onClick={() => {
            onAdd(sharedGroupId);
            onClose();
          }}
          text={"保存する"}
        />
      </section>
    </BaseModal>
  );
};
